// src/auth/ForgotPassword.jsx
import { useState } from "react";
import {
  pageStyle, cardStyle, logoStyle, headingStyle,
  labelStyle, inputStyle, errorStyle, successStyle, btnPrimaryStyle, linkBtnStyle, googleFont,
} from "./authStyles";

export default function ForgotPassword({ onSwitch }) {
  const [email, setEmail] = useState("");
  const [error, setError] = useState("");
  const [busy,  setBusy]  = useState(false);
  const [sent,  setSent]  = useState(false);

  const handleReset = async (e) => {
    e.preventDefault();
    setError(""); setBusy(true);
    try {
      await fetch("/.netlify/functions/wc-auth-forgot", {
        method:  "POST",
        headers: { "Content-Type": "application/json" },
        body:    JSON.stringify({ email }),
      });
      setSent(true);
    } catch {
      setError("Network error. Please try again.");
    }
    setBusy(false);
  };

  return (
    <div style={pageStyle}>
      {googleFont}
      <div style={cardStyle}>
        <button onClick={() => onSwitch("landing")} style={{ ...linkBtnStyle, marginBottom: 16 }}>← Back to home</button>
        <div style={{ textAlign: "center", marginBottom: 28 }}>
          <div style={logoStyle}>✍️</div>
          <h1 style={{ ...headingStyle, fontSize: 22 }}>Reset Password</h1>
          <p style={{ color: "#8b949e", fontSize: 13, margin: 0 }}>Enter your email and we'll send a reset link.</p>
        </div>

        {sent ? (
          <div style={{ textAlign: "center" }}>
            <div style={{ ...successStyle, textAlign: "left", marginBottom: 16 }}>
              ✓ If an account exists for <strong>{email}</strong>, a reset link is on its way.
            </div>
            <button onClick={() => onSwitch("login")} style={{ ...linkBtnStyle, color: "#388bfd", fontWeight: 700 }}>
              ← Back to Sign In
            </button>
          </div>
        ) : (
          <form onSubmit={handleReset} style={{ display: "flex", flexDirection: "column", gap: 14 }}>
            <div>
              <label style={labelStyle}>Email</label>
              <input type="email" value={email} onChange={e => setEmail(e.target.value)}
                placeholder="you@example.com" required style={inputStyle} />
            </div>
            {error && <div style={errorStyle}>⚠ {error}</div>}
            <button type="submit" disabled={busy} style={btnPrimaryStyle(busy)}>
              {busy ? "Sending…" : "Send Reset Link →"}
            </button>
            <div style={{ textAlign: "center" }}>
              <button onClick={() => onSwitch("login")} style={{ ...linkBtnStyle, color: "#388bfd", fontWeight: 700 }}>
                ← Back to Sign In
              </button>
            </div>
          </form>
        )}
      </div>
    </div>
  );
}
